import { API_BASE_URL } from '../config/api';
import { parseApiResponse } from './apiHelpers';

const BASE = `${API_BASE_URL}/users`;

export const registerUser = async ({ name, email, password, role }) => {
  const res = await fetch(`${BASE}/register`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ name, email, password, role }),
  });
  const data = await parseApiResponse(res);
  return data.data;
};

export const loginUser = async ({ email, password }) => {
  const res = await fetch(`${BASE}/login`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ email, password }),
  });
  const data = await parseApiResponse(res);
  return data.data;
};
